import TravelInsurance from '@data/models/TravelInsurance';
import { getApiBaseUrl } from '@config/index';
import { apiCall } from '../axios';
export class TravelInsuranceService {
    static getOffers(data) {
        // TODO: Remove full url generation when the API is moved to the booking controller
        const url = `${getApiBaseUrl()}/external-offers/v1/offers`;
        return apiCall(TravelInsurance)('post', url, data, {
            contentType: 'application/json',
            headers: { 'x-property-id': data.propertyId },
        });
    }
}
